import { createReducer, on } from '@ngrx/store';

import {
    InitBreadcrumbsSuccess,
} from './breadcrumbs.actions';
import { BreadcrumbsInitialState, BreadcrumbsState } from './breadcrumbs.state';

export const BreadcrumbsReducer = createReducer(
    BreadcrumbsInitialState,

    on(InitBreadcrumbsSuccess, (state: BreadcrumbsState, payload): any => {
        return {
            ...state,
            breadcrumbs: payload.breadcrumbs,
        };
    }),
);
